/* Тексты интерфейса: window.ZG_T_RAW — переводимая настройка секции (key=Text построчно). */
window.ZG_T = (function () {
  var t = {}, raw = window.ZG_T_RAW || '';
  raw.split(/\r?\n/).forEach(function (l) { var i = l.indexOf('='); if (i > 0) t[l.slice(0, i).trim()] = l.slice(i + 1).trim(); });
  return function (k, d) { return t[k] || d; };
})();
/* ZOZOZON Gallery (mir-art): фильтры зала, просмотр работы с листанием, интерьеры в масштабе,
   рама, свет, «ваша комната» (фото покупателя остаётся в браузере), приближение мазков. */
(function () {
  var root = document.querySelector('.zg');
  if (!root) return;
  var ROOMS = (window.ZG_ROOMS || []).filter(function (r) { return r && r.src; });
  var CFG = window.ZG_CFG || {};
  var FRAME_CM = 12;  /* рама с паспарту добавляет к холсту около 12 см по ширине */
  var t = window.ZG_T;
  var FRAMES = [['wood', t('frame_wood', 'Dark wood')], ['oak', t('frame_oak', 'Natural oak')], ['gold', t('frame_gold', 'Gold')], ['black', t('frame_black', 'Black')], ['none', t('frame_none', 'No frame')]];
  var LIGHTS = [['day', t('light_day', 'Daylight')], ['evening', t('light_evening', 'Warm evening')], ['spot', t('light_spot', 'Gallery spotlight')], ['night', t('light_night', 'Night')]];

  /* первые N работ зала, остальные — по кнопке «Show all» */
  function limitRoom(room, on) {
    var wall = room.querySelector('.zg-wall'), more = room.querySelector('.zg-more');
    if (!wall || !more) return;
    var lim = parseInt(wall.dataset.limit, 10) || 0, all = wall.querySelectorAll('.zg-work'), n = 0;
    all.forEach(function (w) { w.classList.remove('is-over'); if (!w.hidden) n++; });
    if (!on || room.dataset.open === '1' || !lim || n <= lim) { more.hidden = true; return; }
    var k = 0;
    all.forEach(function (w) { if (!w.hidden && ++k > lim) w.classList.add('is-over'); });
    more.hidden = false;
    more.querySelector('button').textContent = t('show_all_n', 'Show all {n} works').replace('{n}', n);
  }
  root.querySelectorAll('[data-room]').forEach(function (room) {
    limitRoom(room, true);
    var b = room.querySelector('.zg-more__btn');
    if (b) b.addEventListener('click', function () { room.dataset.open = '1'; limitRoom(room, true); });
  });

  /* липкая панель залов: подсветка текущего */
  var nav = root.querySelector('.zg-roomnav');
  if (nav && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        nav.querySelectorAll('a').forEach(function (a) { a.setAttribute('aria-current', a.dataset.nav === e.target.id ? 'true' : 'false'); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    nav.querySelectorAll('a').forEach(function (a) { var t = document.getElementById(a.dataset.nav); if (t) io.observe(t); });
  }

  /* фильтры в каждом зале */
  root.querySelectorAll('[data-room]').forEach(function (room) {
    var chips = room.querySelector('.zg-chips');
    if (!chips) return;
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('.zg-chip');
      if (!b) return;
      chips.querySelectorAll('.zg-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
      var kw = b.dataset.kw || '';
      var re = kw && kw !== '@available' ? new RegExp(kw, 'i') : null;
      room.querySelectorAll('.zg-work').forEach(function (w) {
        w.hidden = !(!kw || (kw === '@available' ? w.dataset.av === '1' : re.test(w.dataset.title)));
      });
      limitRoom(room, !kw);
    });
  });

  var lb = root.querySelector('.zg-lb');
  if (!lb || typeof lb.showModal !== 'function') return;
  var art = lb.querySelector('.zg-lb__art');
  var list = [], idx = 0;
  var st = { view: 'wall', lastRoom: '0', frame: null, light: 'day', own: null, ownPos: { x: .5, y: .38, w: .3 }, zoom: false };

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; return e; }
  function group(title, opts, cur, onPick) {
    var g = el('div', 'zg-opt');
    g.appendChild(el('span', 'zg-opt__t', title));
    var row = el('div', 'zg-opt__row');
    opts.forEach(function (o) {
      var b = el('button', ''); b.type = 'button'; b.textContent = o[1];
      b.setAttribute('aria-pressed', cur === o[0] ? 'true' : 'false');
      b.addEventListener('click', function () { onPick(o[0]); });
      row.appendChild(b);
    });
    g.appendChild(row);
    return g;
  }
  /* размер холста: из полей товара (data-wcm / data-hcm), иначе условный по ориентации */
  function sizeCm(w, ratio) {
    var wc = parseFloat(w.dataset.wcm), hc = parseFloat(w.dataset.hcm);
    if (wc && hc) return { w: wc, h: hc, real: true };
    if (wc) return { w: wc, h: wc / ratio, real: true };
    if (hc) return { w: hc * ratio, h: hc, real: true };
    var dw = ratio >= 1 ? (CFG.defH || 80) : (CFG.defV || 60);
    return { w: dw, h: dw / ratio, real: false };
  }
  function makeFrame(w, full, alt) {
    var f = el('div', 'zg-frame zg-frame--' + (w.dataset.wip ? 'none' : (st.frame || w.dataset.frame || 'wood')));
    var m = el('div', 'zg-mat'); var img = el('img'); img.alt = alt;
    var thumb = w.querySelector('.zg-work__open img');
    img.src = (thumb && (thumb.currentSrc || thumb.src)) || full;
    if (full && img.src !== full) { var big = new Image(); big.onload = function () { img.src = full; }; big.src = full; }
    m.appendChild(img); f.appendChild(m);
    return { f: f, img: img };
  }
  function paint() {
    var w = list[idx];
    if (w.dataset.wip) st.view = 'wall';
    var full = w.querySelector('.zg-work__open').dataset.full;
    var label = w.querySelector('.zg-label');
    var alt = w.querySelector('img').alt;
    var fr = makeFrame(w, full, alt);
    art.innerHTML = '';
    if (st.view === 'wall') {
      var wrap = el('div', 'zg-zoomwrap' + (st.zoom ? ' is-zoom' : ''));
      wrap.appendChild(fr.f);
      wrap.title = st.zoom ? t('zoom_out', 'Click to zoom out') : t('zoom_in', 'Click to see the brushwork');
      wrap.addEventListener('click', function () { st.zoom = !st.zoom; paint(); });
      wrap.addEventListener('mousemove', function (e) {
        if (!st.zoom) return;
        var r = wrap.getBoundingClientRect();
        fr.f.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      art.appendChild(wrap);
    } else {
      var own = st.view === 'own';
      var r = own ? { src: st.own, x: st.ownPos.x, y: st.ownPos.y, w: st.ownPos.w } : ROOMS[+st.view];
      var scene = el('div', 'zg-room-view zg-light--' + st.light + (own ? ' is-own' : ''));
      scene.style.backgroundImage = 'url(' + r.src + ')';
      LIGHTS.forEach(function (L) { scene.appendChild(el('div', 'zg-L zg-L--' + L[0])); });
      var place = function () {
        var ratio = (fr.img.naturalWidth || 4) / (fr.img.naturalHeight || 3);
        var cm = sizeCm(w, ratio);
        /* доля ширины сцены = (холст + рама) / видимая ширина стены, см */
        var wPct = own ? r.w : Math.min(.7, Math.max(.06, (cm.w + FRAME_CM) / (r.cm || 330)));
        fr.f.style.width = wPct * 100 + '%';
        fr.f.style.left = r.x * 100 + '%';
        fr.f.style.top = r.y * 100 + '%';
        st.note = own ? t('drag_hint', 'Drag the painting to place it, use the slider for size.')
          : t('shown_at', 'Shown at about {w} × {h} cm.').replace('{w}', Math.round(cm.w)).replace('{h}', Math.round(cm.h)) + (cm.real ? '' : ' ' + t('exact_size', 'Exact size on request.'));
        var note = lb.querySelector('.zg-sizenote');
        if (note) note.textContent = st.note;
      };
      fr.img.complete ? place() : fr.img.addEventListener('load', place);
      scene.appendChild(fr.f);
      if (own) {
        var drag = null;
        fr.f.addEventListener('pointerdown', function (e) { drag = scene.getBoundingClientRect(); fr.f.setPointerCapture(e.pointerId); });
        fr.f.addEventListener('pointermove', function (e) {
          if (!drag) return;
          st.ownPos.x = Math.min(.95, Math.max(.05, (e.clientX - drag.left) / drag.width));
          st.ownPos.y = Math.min(.95, Math.max(.05, (e.clientY - drag.top) / drag.height));
          fr.f.style.left = st.ownPos.x * 100 + '%'; fr.f.style.top = st.ownPos.y * 100 + '%';
        });
        fr.f.addEventListener('pointerup', function () { drag = null; });
      }
      art.appendChild(scene);
    }
    lb.querySelector('.zg-lb__count').textContent = (idx + 1) + ' / ' + list.length;
    lb.querySelector('.zg-lb__t').textContent = label.querySelector('.zg-label__t').textContent;
    lb.querySelector('.zg-lb__a').textContent = label.querySelector('.zg-label__a').textContent;
    lb.querySelector('.zg-lb__p').innerHTML = label.querySelector('.zg-label__p').innerHTML;
    var buy = lb.querySelector('.zg-lb__buy');
    buy.innerHTML = '';
    var tpl = w.querySelector('template.zg-work__buy');
    if (tpl) buy.appendChild(tpl.content.cloneNode(true));

    var tools = lb.querySelector('.zg-lb__tools');
    tools.innerHTML = '';
    if (w.dataset.wip) { st.view = 'wall'; return; }
    var views = [['wall', t('gallery_wall', 'Gallery wall')]].concat(ROOMS.map(function (r, i) { return [String(i), t('room' + (i + 1), r.name)]; }));
    views.push(['own', t('your_room', 'Your room')]);
    tools.appendChild(group(t('see_it', 'See it'), views, st.view, function (v) {
      if (v === 'own' && !st.own) { fileIn.click(); return; }
      st.view = v; st.zoom = false;
      if (v !== 'wall' && v !== 'own') st.lastRoom = v;
      paint();
    }));
    if (st.view === 'own') {
      var sz = el('label', 'zg-opt zg-opt--size', '<span class="zg-opt__t">' + t('size_on_wall', 'Size on your wall') + '</span>');
      var rng = el('input'); rng.type = 'range'; rng.min = 8; rng.max = 80; rng.value = Math.round(st.ownPos.w * 100);
      rng.addEventListener('input', function () { st.ownPos.w = rng.value / 100; fr.f.style.width = rng.value + '%'; });
      sz.appendChild(rng);
      sz.appendChild(el('span', 'zg-opt__hint', t('photo_private', 'Your photo stays on your device.')));
      var again = el('button', 'zg-linkbtn', t('another_photo', 'Use another photo')); again.type = 'button';
      again.addEventListener('click', function () { fileIn.click(); });
      sz.appendChild(again);
      tools.appendChild(sz);
    }
    tools.appendChild(group(t('frame', 'Frame'), FRAMES, st.frame || w.dataset.frame || 'wood', function (v) { st.frame = v; paint(); }));
    if (st.view !== 'wall') {
      /* свет меняется без перерисовки: слои плавно перекрываются */
      var lg = group(t('light', 'Light'), LIGHTS, st.light, function (v) {
        st.light = v;
        var sc = art.querySelector('.zg-room-view');
        LIGHTS.forEach(function (L) { sc.classList.toggle('zg-light--' + L[0], L[0] === v); });
        lg.querySelectorAll('button').forEach(function (b, i) { b.setAttribute('aria-pressed', LIGHTS[i][0] === v ? 'true' : 'false'); });
      });
      tools.appendChild(lg);
      var nt = el('p', 'zg-sizenote'); nt.textContent = st.note || ''; tools.appendChild(nt);
    }
  }

  var fileIn = el('input'); fileIn.type = 'file'; fileIn.accept = 'image/*'; fileIn.hidden = true;
  lb.appendChild(fileIn);
  fileIn.addEventListener('change', function () {
    var f = fileIn.files && fileIn.files[0];
    if (!f) return;
    if (st.own) URL.revokeObjectURL(st.own);
    st.own = URL.createObjectURL(f);
    st.view = 'own';
    paint();
  });

  function open(w, view) {
    var room = w.closest('[data-room]');
    list = Array.prototype.filter.call(room.querySelectorAll('.zg-work'), function (x) { return !x.hidden; });
    idx = Math.max(0, list.indexOf(w));
    st.view = view || 'wall'; st.frame = null; st.zoom = false;
    paint();
    lb.showModal();
  }
  function step(d) { if (!list.length) return; idx = (idx + d + list.length) % list.length; st.zoom = false; paint(); }

  root.addEventListener('click', function (e) {
    var inroom = e.target.closest('.zg-work__room');
    if (inroom) { e.preventDefault(); open(inroom.closest('.zg-work'), ROOMS.length ? st.lastRoom : 'wall'); return; }
    var o = e.target.closest('.zg-work__open');
    if (o) { e.preventDefault(); open(o.closest('.zg-work')); }
  });
  lb.querySelector('.zg-lb__prev').addEventListener('click', function () { step(-1); });
  lb.querySelector('.zg-lb__next').addEventListener('click', function () { step(1); });
  lb.querySelector('.zg-lb__close').addEventListener('click', function () { lb.close(); });
  lb.addEventListener('keydown', function (e) {
    if (e.target.tagName === 'INPUT') return;
    if (e.key === 'ArrowLeft') step(-1);
    if (e.key === 'ArrowRight') step(1);
  });
  var x0 = null;
  art.addEventListener('touchstart', function (e) { x0 = st.view === 'own' ? null : e.touches[0].clientX; }, { passive: true });
  art.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
  });
})();

/* Корзина без ухода со страницы: /cart/add.js, счётчик в шапке темы, подсказка с переходом к оформлению. */
(function () {
  function toast(html) {
    var t = document.querySelector('.zg-toast');
    var host = document.querySelector('dialog[open]') || document.body;
    if (t && t.parentNode !== host) { t.remove(); t = null; }
    if (!t) { t = document.createElement('div'); t.className = 'zg-toast'; t.setAttribute('role', 'status'); host.appendChild(t); }
    t.innerHTML = html;
    clearTimeout(t._h); t._h = setTimeout(function () { t.remove(); }, 9000);
    var k = t.querySelector('[data-keep]'); if (k) k.addEventListener('click', function () { t.remove(); });
  }
  function bump(count) {
    var a = document.getElementById('cart-icon-bubble');
    if (!a) return;
    var b = a.querySelector('.cart-count-bubble');
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
    b.innerHTML = count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '';
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form.zg-buy');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || window.ZG_T('add_failed', 'Could not add to cart'));
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        bump(cart.item_count);
        var T = window.ZG_T; toast('<span>' + T('added', 'Added to your cart.') + '</span><a class="zg-btn" href="' + root + 'checkout">' + T('checkout', 'Checkout') + '</a><a class="zg-btn zg-btn--ghost" href="' + root + 'cart">' + T('view_cart', 'View cart') + '</a><button type="button" class="zg-btn zg-btn--ghost" data-keep>' + T('keep_browsing', 'Keep browsing') + '</button>');
      })
      .catch(function (err) { toast('<span>' + String(err.message || err).replace(/</g, '&lt;') + '</span><button type="button" class="zg-btn zg-btn--ghost" data-keep>OK</button>'); })
      .then(function () { if (btn) btn.disabled = false; });
  });
})();

/* Страница картины: оригинал / интерьеры / приближение, рама и свет, фото товара. */
(function () {
  var zk = document.querySelector('.zk');
  if (!zk) return;
  var art = zk.querySelector('.zk-art'), views = zk.querySelector('.zk-views'), tools = zk.querySelector('.zk-tools');
  var ROOMS = (window.ZG_ROOMS || []).filter(function (r) { return r && r.src; });
  var CFG = window.ZG_CFG || {};
  var t = window.ZG_T;
  var FR = [['wood', t('frame_wood', 'Dark wood')], ['oak', t('frame_oak', 'Natural oak')], ['gold', t('frame_gold', 'Gold')], ['black', t('frame_black', 'Black')], ['none', t('frame_none', 'No frame')]];
  var LI = [['day', t('light_day', 'Daylight')], ['evening', t('light_evening', 'Warm evening')], ['spot', t('light_spot', 'Gallery spotlight')], ['night', t('light_night', 'Night')]];
  var st = { view: 'original', frame: art.dataset.frame || 'wood', light: 'day', full: art.dataset.full };
  var origHTML = art.innerHTML;
  var thumbImg = art.querySelector('img');
  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h) e.textContent = h; return e; }
  function sizeCm(ratio) {
    var wc = parseFloat(art.dataset.wcm), hc = parseFloat(art.dataset.hcm);
    if (wc && hc) return { w: wc, h: hc, real: true };
    var dw = ratio >= 1 ? (CFG.defH || 80) : (CFG.defV || 60);
    return { w: dw, h: dw / ratio, real: false };
  }
  function setFrame(root) {
    root.querySelectorAll('.zg-frame').forEach(function (f) { f.className = 'zg-frame zg-frame--' + st.frame; });
  }
  function render() {
    if (st.view === 'original') {
      art.innerHTML = origHTML;
      var wrap = art.querySelector('.zg-zoomwrap'), f = art.querySelector('.zg-frame'), im = art.querySelector('img');
      if (st.full && im) { var big = new Image(); big.onload = function () { im.removeAttribute('srcset'); im.src = st.full; }; big.src = st.full; }
      setFrame(art);
      wrap.addEventListener('click', function () { wrap.classList.toggle('is-zoom'); });
      wrap.addEventListener('mousemove', function (e) {
        if (!wrap.classList.contains('is-zoom')) return;
        var r = wrap.getBoundingClientRect();
        f.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    } else {
      var r = ROOMS[+st.view];
      var scene = el('div', 'zg-room-view zg-light--' + st.light);
      scene.style.backgroundImage = 'url(' + r.src + ')';
      LI.forEach(function (L) { scene.appendChild(el('div', 'zg-L zg-L--' + L[0])); });
      var f2 = el('div', 'zg-frame zg-frame--' + st.frame), m = el('div', 'zg-mat'), im2 = el('img');
      im2.alt = thumbImg ? thumbImg.alt : ''; im2.src = (thumbImg && (thumbImg.currentSrc || thumbImg.src)) || st.full;
      m.appendChild(im2); f2.appendChild(m); scene.appendChild(f2);
      var place = function () {
        var ratio = (im2.naturalWidth || 4) / (im2.naturalHeight || 3), cm = sizeCm(ratio);
        f2.style.width = Math.min(70, Math.max(6, (cm.w + 12) / (r.cm || 330) * 100)) + '%';
        f2.style.left = r.x * 100 + '%'; f2.style.top = r.y * 100 + '%';
        var n = tools.querySelector('.zg-sizenote');
        if (n) n.textContent = t('shown_at', 'Shown at about {w} × {h} cm.').replace('{w}', Math.round(cm.w)).replace('{h}', Math.round(cm.h)) + (cm.real ? '' : ' ' + t('exact_size', 'Exact size on request.'));
      };
      im2.complete ? place() : im2.addEventListener('load', place);
      art.innerHTML = ''; art.appendChild(scene);
    }
    drawControls();
  }
  function btns(box, opts, cur, onPick) {
    opts.forEach(function (o) {
      var b = el('button', '', o[1]); b.type = 'button';
      b.setAttribute('aria-pressed', cur === o[0] ? 'true' : 'false');
      b.addEventListener('click', function () { onPick(o[0], b); });
      box.appendChild(b);
    });
  }
  function drawControls() {
    views.innerHTML = '';
    btns(views, [['original', t('original', 'Original')]].concat(ROOMS.map(function (r, i) { return [String(i), t('room' + (i + 1), r.name)]; })), st.view, function (v) { st.view = v; render(); });
    tools.innerHTML = '';
    btns(tools, FR, st.frame, function (v) { st.frame = v; render(); });
    if (st.view !== 'original') {
      tools.appendChild(el('span', 'zk-sep'));
      btns(tools, LI, st.light, function (v) {
        st.light = v;
        var sc = art.querySelector('.zg-room-view');
        LI.forEach(function (L) { sc.classList.toggle('zg-light--' + L[0], L[0] === v); });
        tools.querySelectorAll('button').forEach(function (b) { var k = LI.filter(function (L) { return L[1] === b.textContent; })[0]; if (k) b.setAttribute('aria-pressed', k[0] === v ? 'true' : 'false'); });
      });
      tools.appendChild(el('p', 'zg-sizenote'));
    }
  }
  zk.querySelectorAll('.zk-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      zk.querySelectorAll('.zk-thumb').forEach(function (x) { x.classList.toggle('is-on', x === t); });
      st.full = t.dataset.full; st.view = 'original';
      var tmp = document.createElement('div'); tmp.innerHTML = origHTML;
      var im = tmp.querySelector('img'); if (im) { im.removeAttribute('srcset'); im.src = t.querySelector('img').src; }
      origHTML = tmp.innerHTML; render();
    });
  });
  render();
})();
